import { subject } from '@casl/ability';
import { languageForCountry } from '@restaurant/types';
import { LanguageSchema, type Language } from '@restaurant/api-contracts';
import type { ClientAbility } from '@/lib/ability';

// Names rendered localized via Intl.DisplayNames, same as the country list.
export const LANGUAGE_CODES = LanguageSchema.options;
export type LanguageCode = Language;

function isLanguageCode(value: string | undefined): value is LanguageCode {
  return LANGUAGE_CODES.some((code) => code === value);
}

export function venueLanguageForCountry(country: string): LanguageCode {
  const derived = languageForCountry(country);
  return isLanguageCode(derived) ? derived : 'en';
}

export function nextVenueLanguage(
  saved: { country: string; language: LanguageCode },
  nextCountry: string,
  currentLanguage: LanguageCode,
  pickedByHand: boolean,
): LanguageCode {
  if (pickedByHand || saved.language !== venueLanguageForCountry(saved.country)) {
    return currentLanguage;
  }
  return venueLanguageForCountry(nextCountry);
}

export function languageFollowsCountry(
  clientAbility: ClientAbility,
  franchise: { id: string; restaurantCount: number } | undefined,
): boolean {
  if (!franchise || franchise.restaurantCount !== 1) return false;
  if (clientAbility.status === 'ungated') return true;
  if (clientAbility.status === 'no-context') return false;
  return clientAbility.ability.can('update', subject('Franchise', { id: franchise.id }));
}
